/** Public expertise areas (navbar + /expertises + home). Slugs used in /expertises/:slug routes. */
import { getTechKeywordsForSlug } from './expertisesTechKeywords';

export const EXPERTISE_ITEMS = [
  {

    slug: 'digital-twin',

    icon: 'layers',

    image: 'images/digital-twin-page.jpg',

    titleKey: 'expertises.section.digitalTwin.title',

    homeBodyKey: 'dataDriven.card.digitalTwin.body',

    bodyKey: 'expertises.section.digitalTwin.body',

    altKey: 'expertises.section.digitalTwin.alt',

    highlightsKeys: [

      'expertises.detail.digitalTwin.h1',

      'expertises.detail.digitalTwin.h2',

      'expertises.detail.digitalTwin.h3',

    ],

  },
  {

    slug: 'blockchain',

    icon: 'link',

    image: 'images/blockchain2.jpg',

    titleKey: 'dataDriven.card.blockchain.title',

    homeBodyKey: 'dataDriven.card.blockchain.body',

    bodyKey: 'expertises.section.blockchain.body',

    altKey: 'dataDriven.card.blockchain.alt',

    highlightsKeys: [

      'expertises.detail.blockchain.h1',

      'expertises.detail.blockchain.h2',

      'expertises.detail.blockchain.h3',

    ],

  },


  {

    slug: 'observatories',

    icon: 'bar-chart',

    image: 'images/observatoire-service.jpg',

    titleKey: 'dataDriven.card.observatories.title',

    homeBodyKey: 'dataDriven.card.observatories.body',

    bodyKey: 'expertises.section.observatories.body',

    altKey: 'dataDriven.card.observatories.alt',

    highlightsKeys: [

      'expertises.detail.observatories.h1',

      'expertises.detail.observatories.h2',

      'expertises.detail.observatories.h3',

    ],

  },

 
  {

    slug: 'cloud-services',

    icon: 'cloud',

    image: 'images/cloud.jpg',

    titleKey: 'expertises.section.cloudServices.title',

    homeBodyKey: 'dataDriven.card.cloudServices.body',

    bodyKey: 'expertises.section.cloudServices.body',

    altKey: 'expertises.section.cloudServices.alt',

    highlightsKeys: [

      'expertises.detail.cloudServices.h1',

      'expertises.detail.cloudServices.h2',

      'expertises.detail.cloudServices.h3',

    ],

  },
  {

    slug: 'ecommerce-cms',

    icon: 'cart',

    image: 'images/ecommerce.jpg',

    titleKey: 'expertises.section.ecommerceCms.title',

    homeBodyKey: 'dataDriven.card.ecommerceCms.body',

    bodyKey: 'expertises.section.ecommerceCms.body',

    altKey: 'expertises.section.ecommerceCms.alt',

    highlightsKeys: [

      'expertises.detail.ecommerceCms.h1',

      'expertises.detail.ecommerceCms.h2',

      'expertises.detail.ecommerceCms.h3',

    ],

  },
  {

    slug: 'tableau-aide-decision-et-machine-learning',

    icon: 'bar-chart-alt',

    image: 'images/dashbord.jpg',

    titleKey: 'expertises.section.decisionDashboard.title',

    homeBodyKey: 'dataDriven.card.decisionDashboard.body',

    bodyKey: 'expertises.section.decisionDashboard.body',

    altKey: 'expertises.section.decisionDashboard.alt',

    highlightsKeys: [

      'expertises.detail.decisionDashboard.h1',

      'expertises.detail.decisionDashboard.h2',

      'expertises.detail.decisionDashboard.h3',

    ],

  },
  {

    slug: 'iot',

    icon: 'cpu',

    image: 'images/iot.jpg',

    titleKey: 'expertises.section.iot.title',

    homeBodyKey: 'dataDriven.card.iot.body',

    bodyKey: 'expertises.section.iot.body',

    altKey: 'expertises.section.iot.alt',

    highlightsKeys: [

      'expertises.detail.iot.h1',

      'expertises.detail.iot.h2',

      'expertises.detail.iot.h3',

    ],

  },

  {

    slug: 'data-ia',

    icon: 'bulb',

    image: 'images/ai.jpg',

    titleKey: 'expertises.section.dataIa.title',

    homeBodyKey: 'dataDriven.card.dataIa.body',

    bodyKey: 'expertises.section.dataIa.body',

    altKey: 'expertises.section.dataIa.alt',

    highlightsKeys: [

      'expertises.detail.dataIa.h1',

      'expertises.detail.dataIa.h2',

      'expertises.detail.dataIa.h3',

    ],

  },

 

 
  {

    slug: 'crm-erp',

    icon: 'grid',

    image: 'images/erp-service.jpg',

    titleKey: 'expertises.section.crmErp.title',

    homeBodyKey: 'dataDriven.card.crmErp.body',

    bodyKey: 'expertises.section.crmErp.body',

    altKey: 'expertises.section.crmErp.alt',

    highlightsKeys: [

      'expertises.detail.crmErp.h1',

      'expertises.detail.crmErp.h2',

      'expertises.detail.crmErp.h3',

    ],

  },
  

  {

    slug: 'gestion-donnees',

    icon: 'server',

    image: 'images/gestion-des-donnees.jpg',

    titleKey: 'expertises.section.dataManagement.title',

    homeBodyKey: 'dataDriven.card.dataManagement.body',

    bodyKey: 'expertises.section.dataManagement.body',

    altKey: 'expertises.section.dataManagement.alt',

    highlightsKeys: [

      'expertises.detail.dataManagement.h1',

      'expertises.detail.dataManagement.h2',

      'expertises.detail.dataManagement.h3',

    ],

  },

  

  

  {

    slug: 'webmobile',

    icon: 'laptop',

    image: 'images/developpement.jpg',

    titleKey: 'dataDriven.card.webmobile.title',

    homeBodyKey: 'dataDriven.card.webmobile.body',

    bodyKey: 'expertises.section.webmobile.body',

    altKey: 'dataDriven.card.webmobile.alt',

    highlightsKeys: [

      'expertises.detail.webmobile.h1',

      'expertises.detail.webmobile.h2',

      'expertises.detail.webmobile.h3',

    ],

  },

];

export function getExpertiseBySlug(slug) {
  const item = EXPERTISE_ITEMS.find((entry) => entry.slug === slug);
  if (!item) return undefined;
  return {
    ...item,
    techKeywordsKeys: getTechKeywordsForSlug(slug),
  };
}

export function enrichExpertiseItem(item) {
  return {
    ...item,
    techKeywordsKeys: getTechKeywordsForSlug(item.slug),
  };
}

